import angular from 'angular';
import declarationProduce from './declarationProduce';
import taskTrace from './taskTrace';
import enterpriseReportQuery from './enterpriseReportQuery';
import smallBusinessGuidelines from './smallBusinessGuidelines';
import businessGuidelines from './businessGuidelines';

export default angular
  .module('declaration.corporateIncomeTax', [
    declarationProduce,
    taskTrace,
    enterpriseReportQuery,
    smallBusinessGuidelines,
    businessGuidelines,
  ])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      $stateProvider.state('declaration.corporateIncomeTax', {
        abstract: true,
        url: '/corporateIncomeTax',
        template: '<div ui-view></div>',
        title: '企业所得税',
      });
    },
  ]).name;



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/index.js